export async function getActualVariant(regionCode: string) {
    return getFromBackActualVariant(regionCode);
}

export interface IVariantInfo {
    budget_request_form_total: number;
    budget_cost_data: number;
    budget_income_data: number;
}

export interface IVariant {
    _showDetails: boolean;
    id: number;
    name_ru: string;
    name_kk?: any;
    name_en?: any;
    year: number;
    data_type?: any;
    attribute: boolean;
    status: boolean;
    basis_ru?: any;
    basis_kk?: any;
    date_time?: any;
    date_start?: any;
    date_ueb?: any;
    date_abp?: any;
    variant_uuid: string;
    is_deleted: boolean;
    region_code?: string;
    prev_variant?: string;
    variant_info?: IVariantInfo;
    user_name?: string;
    end_date?: any;
}

export interface IVariantBase {
    id: number;
    name_ru: string;
    name_kk?: any;
    name_en?: any;
    year: number;
    data_type?: any;
    attribute?: any;
    status?: any;
    basis_ru?: any;
    basis_kk?: any;
    date_time?: any;
    date_start?: any;
    date_ueb?: any;
    date_abp?: any;
    variant_uuid: string;
    is_deleted?: any;
    region_code?: string;
    prev_variant?: string;
    update_date?: any;
    user_name?: string;
    disabled: boolean;
}

export interface IUserModules {
    id: number;
    name_ru: string;
    modules?: string;
    access_level: number;
    data_type?: any;
    operations?: string;
}

interface IDictBase {
    id?: number,
    name_kk: string | null,
    name_ru: string,
    name?: string,
    beg_date?: string | null,
    end_date?: string | null,
    idArr?: number,
}

export interface ICurDataType extends IDictBase {
    code: string | null,
}

async function getFromBackActualVariant(region_code: string) {
    let result = '';
    try {
        await fetch('/api-py/get-actual-variant/' + region_code)
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (error) {
        console.log('Ошибка запроса getFromBackActualVariant', error);
    }
    return result;
}

export async function getFromBackActualVariantByYear(region_code: string, cur_year: string) {
    let result = '';
    try {
        await fetch('/api-py/get-actual-variant/' + region_code+'/'+cur_year)
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (error) {
        console.log('Ошибка запроса getFromBackActualVariant', error);
    }
    return result;
}

export async function loadVariants() {
    let result: IVariant [] = [];
    try {
        await fetch('/api-py/get-variants')
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (err) {
        throw 'Ошибка запроса вариантов';
    }
    return result;
}

export async function loadVariantsByRegionCode(region: string) {
    let result: IVariant [] = [];
    try {
        await fetch('/api-py/get-variants-by-region/' + region)
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (err) {
        throw 'Ошибка запроса вариантов';
    }
    return result;
}

export async function loadVariantByUiid(uiid: string)  {
    let result!: IVariant;
    try {
        const response = await fetch('/api-py/get-variant-by-uiid/' + uiid)
        result = await response.json();
        return result;
    } catch (err) {
        throw 'Ошибка запроса вариантов';
    }
    return result;
}

export async function loadVariantsByUserId(user_id: string) {
    let result: IVariant [] = [];
    try {
        await fetch('/api-py/get-variants-by-userid/' + user_id)
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (err) {
        throw 'Ошибка запроса вариантов';
    }
    return result;
}

export async function loadPrevVariantsByRegionCode(region: string, variant_uuid: string) {
    let res: string = '';
    let variants: IVariant[] = []
    await loadVariantsByRegionCode(region).then(data => {
        variants = data
    })
    for (const v of variants) {
        if ((v.prev_variant) && (v.variant_uuid == variant_uuid)) {
            res = v.prev_variant
        }
    }
    return res
}

export async function loadVariantsWithEndDate() {
    let result: IVariant [] = [];
    try {
        await fetch('/api-py/get-variants-with-end-date')
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (err) {
        throw 'Ошибка запроса вариантов';
    }
    return result;
}

export async function loadUserLevels(userUiid: string) {
    let result: IUserModules[]= [];
    try {
        await fetch('/api-py/user-modules/' + userUiid)
            .then(response => response.json())
            .then(json => {
                result = json;
            });
    } catch (err) {
        throw 'Ошибка запроса уровней пользователя';
    }
    return result;
}

export async function loadDataTypeDict() {
    let result: ICurDataType[] = [];
    try {
        const response = await fetch('/api-py/dict_budget_data_types/')
        if (response.status === 200) {
            result = await response.json();
        } else {
            throw 'Ошибка запроса Видов данных';
        }
    } catch (error) {
        result = [];
        throw 'Ошибка запроса Видов данных';
    }
    return result;
}